import { useState } from 'react';
import { GoChevronDown, GoChevronLeft } from 'react-icons/go';

function ExpandablePanel({ header, orderButtons, children }) {
  const [expanded, setExpanded] = useState(false);

  const handleClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="mb-2 ">
      <div className="flex p-1 justify-between items-center">
        <div className="flex flex-row items-center justify-between">
          <div>
            {orderButtons}
          </div>
          <div className='cursor-pointer' onClick={handleClick}>
            {header}
          </div>
        </div>
        <div onClick={handleClick} className="cursor-pointer">
          {expanded ? <GoChevronDown /> : <GoChevronLeft />}
        </div>
      </div>
      {expanded && <div className="p-1 ">{children}</div>}
    </div>
  );
}

export default ExpandablePanel;